export default __webpack_public_path__ + "static/media/af.77f5da1e.svg";